export default "__VITE_ASSET__Tu7cLFg___"